import { Store } from "@tanstack/react-store";

export enum SettingsMenu {
    Account = "account",
    Homepage = "homepage",
    UserManagement = "userManagement",
    EmailSignature = "emailSignature",
    Notifications = "notifications",
    MyLicense = "myLicense",
    ModelManagement = "modelManagement",
    Resources = "resources",
    LegalPages = "legalPages",
}

const settingsStore = new Store({
    settingsDialogOpen: false as boolean,
    settingsDialogTarget: null as SettingsMenu | null,
});

export const setSettingsDialogOpen = (open: boolean) => {
    settingsStore.setState((state) => ({
        ...state,
        settingsDialogOpen: open,
    }));
};

export const setSettingsDialogTarget = (target: SettingsMenu | null) => {
    settingsStore.setState((state) => ({
        ...state,
        settingsDialogTarget: target,
    }));
};

export const setSettingsDialogTargetAndOpen = (target: SettingsMenu | null) => {
    settingsStore.setState((state) => ({
        ...state,
        settingsDialogTarget: target,
        settingsDialogOpen: true,
    }));
};

export default settingsStore;
